import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("da-lang") || "en");
  useEffect(() => {
    localStorage.setItem("da-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const L = (pair) => (pair && typeof pair === "object" ? pair[lang] ?? pair.en : pair);
  return <LangCtx.Provider value={{ lang, setLang, L }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}
